import './index.css';

import * as React from 'react';
import { connect } from 'react-redux';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';

import {
  destroyMemo,
  readMemo,
  readMemosRelated,
  truncateMemos,
  updateMemo,
  updateMemos
} from '../../actions/memo';
import Memo from '../../entities/Memo';
import Cancel from '../../res/img/cancel_gray.svg';
import Navigation from '../Navigation/global';
import MemoSort from '../Navigation/memoSort';
import MemoItem from './item';
import OtherActions from './otherActions';

interface IProps {
  account: Member;
  memos: Memo[];
  members: Member[];
  groups: Group[];
  readMemo: (memo: Memo) => void;
  updateMemo: (memo: Memo) => void;
  updateMemos: (memo: Memo[]) => void;
  destroyMemo: (memo: Memo) => void;
  readMemosRelated: (offset: number, limit: number) => void;
  truncateMemos: () => void;
  isLoading: boolean;
}

interface IState {
  doesShowPopup: boolean;
  popupMemoId: number;
  sortFunc: any;
  filterFunc: any;
  isApiLoaded: boolean;
  offset: number;
  countMemos: number;
  isFullyLoaded: boolean;
  isLoading: boolean;
}

class MemoComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      doesShowPopup: false,
      popupMemoId: 0,
      sortFunc: undefined,
      filterFunc: undefined,
      isApiLoaded: false,
      offset: 1,
      isFullyLoaded: false,
      countMemos: 0,
      isLoading: false
    };

    this.setSortFunc = this.setSortFunc.bind(this);
    this.showPopup = this.showPopup.bind(this);
    this.hidePopup = this.hidePopup.bind(this);
    this.loadMoreMemos = this.loadMoreMemos.bind(this);
    this.loadAllMemos = this.loadAllMemos.bind(this);
  }

  componentWillMount() {
    this.props.truncateMemos();
  }

  componentDidUpdate() {
    if (!this.state.isApiLoaded) {
      this.setState({
        isLoading: true,
        isApiLoaded: true
      });
      this.props.readMemosRelated(0, 30);
      // this.props.readMemosRelated(0, 1000);
    }

    if (this.state.countMemos !== this.props.memos.length) {
      this.setState({
        countMemos: this.props.memos.length,
        isFullyLoaded: this.props.memos.length - this.state.countMemos !== 30
      });
    }
  }

  render() {
    let memos = this.props.memos.filter(
      memo =>
        memo.reporters.includes(this.props.account.id) ||
        memo.performers.includes(this.props.account.id) ||
        memo.watchers.includes(this.props.account.id)
    );

    if (this.state.filterFunc !== undefined) {
      memos = memos.filter(this.state.filterFunc);
    }

    if (this.state.sortFunc !== undefined) {
      memos = memos.sort(this.state.sortFunc);
    }

    const popupMemo = this.props.memos.find(
      memo => memo.id === this.state.popupMemoId
    );

    return (
      <div id="MemoIndex">
        <Navigation />

        <div id="NavigationFunction">
          <div />
          <div id="NavigationFunctionRight">
            <MemoSort
              setSortFunc={this.setSortFunc}
              account={this.props.account}
            />
            <OtherActions
              account={this.props.account}
              memos={memos}
              members={this.props.members}
              updateMemos={this.props.updateMemos}
            />
          </div>
        </div>

        {this.props.members.length && this.props.groups.length ? (
          <div id="Memos">
            {memos.length ? (
              <div>{memos.map(memo => this.renderMemoItem(memo))}</div>
            ) : (
              <div id="NoMemo">メモがありません</div>
            )}

            {!this.state.isFullyLoaded ? (
              <div id="LoadContainer">
                <button id="LoadMore" onClick={this.loadMoreMemos}>
                  さらに読み込む
                </button>
                <button id="LoadAll" onClick={this.loadAllMemos}>
                  すべて読み込む
                </button>
              </div>
            ) : (
              <div id="FullyLoaded">すべてのメモを読み込みました</div>
            )}
          </div>
        ) : null}

        {this.state.doesShowPopup && popupMemo !== undefined ? (
          <div id="PopupMemo">
            <div className="Delete" onClick={this.hidePopup}>
              <img src={Cancel} />
            </div>
            <div id="PopupMemoItem">
              <MemoItem
                memo={popupMemo}
                groups={this.props.groups}
                group={
                  this.props.groups.find(
                    group => group.id === popupMemo.groupId
                  ) as Group
                }
                members={this.props.members}
                account={this.props.account}
                updateMemo={this.props.updateMemo}
                destroyMemo={this.props.destroyMemo}
                togglePopup={this.showPopup}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  renderMemoItem(memo: Memo) {
    const memoGroup = this.props.groups.find(
      group => group.id === memo.groupId
    );
    if (memoGroup !== undefined) {
      return (
        <MemoItem
          key={memo.id}
          memo={memo}
          group={memoGroup}
          groups={this.props.groups}
          members={this.props.members}
          account={this.props.account}
          updateMemo={this.props.updateMemo}
          destroyMemo={this.props.destroyMemo}
          togglePopup={this.showPopup}
        />
      );
    } else {
      return null;
    }
  }

  setSortFunc(sortFunc: any, filterFunc: any) {
    this.setState({
      sortFunc,
      filterFunc
    });
  }

  showPopup(memoId: number) {
    const memo = new Memo();
    memo.id = memoId;
    this.props.readMemo(memo);
    this.setState({
      doesShowPopup: true,
      popupMemoId: memoId
    });
  }

  hidePopup(e: any) {
    this.setState({
      doesShowPopup: false,
      popupMemoId: 0
    });
  }

  loadMoreMemos(e: any) {
    this.props.readMemosRelated(this.state.offset, 30);
    this.setState({
      isLoading: true,
      offset: this.state.offset + 1
    });
  }

  loadAllMemos(e: any) {
    this.props.readMemosRelated(0, 200);
    this.setState({
      offset: this.state.offset + 1,
      isFullyLoaded: true
    });
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  account: state.Account,
  members: state.Member,
  groups: state.Group,
  memos: state.Memo,
  isLoading: state.Network.calling.includes('memosreadMemosRelated')
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    readMemo(memo: Memo) {
      dispatch(readMemo(memo));
    },
    updateMemo(memo: Memo) {
      dispatch(updateMemo(memo));
    },
    updateMemos(memos: Memo[]) {
      dispatch(updateMemos(memos));
    },
    readMemosRelated(offset: number, limit: number) {
      dispatch(readMemosRelated(offset, limit));
    },
    destroyMemo(memo: Memo) {
      dispatch(destroyMemo(memo));
    },
    truncateMemos() {
      dispatch(truncateMemos());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemoComponent);



// WEBPACK FOOTER //
// ./src/components/Memo/index.tsx